import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import GymLogo from '../img/commisions/gym-Commision.jpg';
import Bonnita from '../img/commisions/bonnitas-Fresitas.jpg';
import JayNicoleFit from '../img/commisions/jayNicoleFit.jpg';
import DripWash from '../img/commisions/drip-Wash.jpg';
import Tanya from '../img/commisions/TanyaFit.jpg';
import Beauty from '../img/commisions/Beauty.jpg';
import Fresca from '../img/commisions/Frescas-Sandy.jpg';
import Event from '../img/commisions/Fresca-Event.jpg';


function Commisions() {
    return (
        <>
            <Container className="page-Title" fluid>
                <h1>*Art Commisions*</h1>
            </Container>
            <Container className="No-Left-Right flex-Sec space-Bottom-Top" fluid>
                <Row>
                    <Col md>
                        <Image src={Bonnita} className="art-Img-width left-Start flex-Sec" />
                    </Col>
                    <Col md>
                        <Image src={JayNicoleFit} className="art-Img-width right-Start flex-Sec" />
                    </Col>
                </Row>
                <Image src={GymLogo} className="space-Bottom-Top" fluid />
                <Row>
                    <Col md>
                        <Image src={DripWash} className="art-Img-width left-Start flex-Sec" />
                    </Col>
                    <Col md>
                        <Image src={Tanya} className="art-Img-width right-Start flex-Sec" />
                    </Col>
                </Row>
                <Image src={Event} className="space-Bottom-Top" fluid />
                <Row>
                    <Col md>
                        <Image src={Beauty} className="art-Img-width left-Start flex-Sec" />
                    </Col>
                    <Col md>
                        <Image src={Fresca} className="art-Img-width right-Start flex-Sec" />
                    </Col>
                </Row>
            </Container>
        </>

    );
}
export default Commisions;